import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { action, computed, observable } from 'mobx';
import { Model } from 'core/model/Model';
import $lookups from 'app/stores/$lookups';
import { SITE_TYPES } from 'app/util/constants';
const SITE_LOCATION_FIELDS = ['address', 'city', 'region', 'postal', 'countryName'];
// Asynchronous load of $devices to ensure no import loop can occur - we aim to delete this ASAP
let $devices;
import('app/stores/device/$devices').then(({
  default: store
}) => {
  $devices = store;
});
let SiteModel = (_class = class SiteModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "countryName", _descriptor, this);
    this.totalCost = void 0;
  }
  get urlRoot() {
    return '/api/ui/sites';
  }
  get sortValues() {
    return {
      country: model => model.countryName
    };
  }
  get siteLocation() {
    const location = [];
    SITE_LOCATION_FIELDS.forEach(field => {
      const value = this[field] || this.get(field);
      if (value) {
        location.push(value);
      }
    });
    return location.join(', ');
  }
  get type() {
    const {
      type
    } = this.get('metadata') || {};
    return type && SITE_TYPES[type] || 'Other';
  }

  /**
   * @deprecated we aim to kill this ASAP - site device counts now come from the backend (device_count etc)
   */
  get devices() {
    const id = this.get('id');
    return $devices?.activeDeviceSummaries?.filter(d => d.site_id === id) || [];
  }
  get numDevices() {
    const deviceCount = this.get('device_count');
    if (!deviceCount) {
      return 'No devices';
    }
    return deviceCount > 1 ? `${deviceCount} Devices` : '1 Device';
  }
  get hasCloudDevices() {
    return this.get('cloudDevices');
  }
  get siteType() {
    const metadata = this.get('metadata');
    const siteTypes = {
      dataCenter: 'Data Center',
      cloud: 'Cloud',
      branch: 'Branch/Building',
      connectivity: 'Connectivity PoP',
      customer: 'Customer/Partner',
      other: 'Other'
    };
    return metadata && metadata.type && siteTypes[metadata.type] || 'Site';
  }
  save(attributes = {}, options) {
    if (attributes.title) {
      attributes.title = attributes.title.trim();
    }
    const onSuccess = success => {
      this.doLookups();
      return success;
    };
    return super.save({
      ...attributes
    }, options).then(onSuccess);
  }
  doLookups() {
    const country = this.get('country');
    if (country) {
      $lookups.countries(country).then(action(countries => {
        const countryOption = countries.find(option => option.value === country);
        this.countryName = countryOption ? countryOption.label : country;
        this.setLastUpdated();
      }));
    } else {
      this.countryName = '';
      this.setLastUpdated();
    }
  }
  set(dataOrFieldName = {}, fieldData) {
    if (typeof dataOrFieldName === 'string') {
      super.set(dataOrFieldName, fieldData);
    } else {
      super.set(dataOrFieldName);
    }
    this.doLookups();
    return this;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "countryName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "siteLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "type", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "type"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "devices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "devices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numDevices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "numDevices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCloudDevices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCloudDevices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doLookups", [action], Object.getOwnPropertyDescriptor(_class.prototype, "doLookups"), _class.prototype), _class);
export default SiteModel;